// extracted by mini-css-extract-plugin
export default {"wrapper":"Price_wrapper__3iv64","overriddenPrice":"Price_overriddenPrice__ovL0V"};